<div class="container">
  <div class="columns is-centered">
    <div class="column"><lacerta-rich-text-block [content]="text"></lacerta-rich-text-block></div>
  </div>
</div>
